import { render, staticRenderFns } from "./NPATypeChip.vue?vue&type=template&id=146a147d"
import script from "./NPATypeChip.vue?vue&type=script&lang=js"
export * from "./NPATypeChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports